import { render, staticRenderFns } from "./SessionsPerPhysioTable.vue?vue&type=template&id=6959dc6e&scoped=true"
import script from "./SessionsPerPhysioTable.vue?vue&type=script&lang=ts"
export * from "./SessionsPerPhysioTable.vue?vue&type=script&lang=ts"
import style0 from "./SessionsPerPhysioTable.vue?vue&type=style&index=0&id=6959dc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959dc6e",
  null
  
)

export default component.exports